/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BarChart } from "../models/http/charts/bar-chart/bar-chart.model";
import { ScatterChart } from "../models/http/charts/scatter-chart/scatter-chart.model";
import { AdvancedFilters } from "../models/http/dashboard/advanced-filters.model";
import { ChartResponse } from "../models/ui/charts.model";
import { DashboardSciHttpService } from "./http/dashboard-sci-http.service";

@Injectable({
	providedIn: "root"
})
export class DashboardSciService {
	constructor(private _dashboardSciHttpService: DashboardSciHttpService) {}

	/**
	 * Retrieves the green score data for a scatter chart within a specified date range and for a specific tenant and functional unit.
	 *
	 * @param filters - The AdvancedFilters payload as defined in the cursor-based filters API spec.
	 * @returns An Observable that emits the scatter chart data.
	 */
	public getGreenScore(filters: AdvancedFilters): Observable<ChartResponse<ScatterChart>> {
		return this._dashboardSciHttpService.getGreenScore(filters);
	}

	/**
	 * Retrieves 10 worst emissions by SCI for a bar chart.
	 *
	 * @param filters - The AdvancedFilters request body.
	 * @returns An Observable that emits the bar chart data.
	 */
	public getWorst10Emissions(filters: AdvancedFilters): Observable<ChartResponse<BarChart>> {
		return this._dashboardSciHttpService.getWorst10Emissions(filters);
	}
}
